<template>
<div class="mt_140">
<ccMenu ref="cc_menu" v-bind:posicao=0></ccMenu>
<ccLoading v-show="loading" ref="cc_loading"></ccLoading>

<section id="mobile">

  <!-- banners -------->
  <div class="container mb-4">
    <div class="row">
      <div class="col-md-4">
        <p class="text-right text_16">
          <a href="https://sokkerduel.com/app/sokkerduelapp.apk">
            <img src="../../assets/image/banner/banner_4.png" class="d-block w-100 border_radius" alt="...">
          </a>
        </p>
      </div>
      <div class="col-md-4">
        <p class="text-left text_16">
            <img src="../../assets/image/banner/banner_1.gif" class="d-block w-100 border_radius" alt="...">
        </p>
      </div>
      <div class="col-md-4">
        <p class="text-center text_16">
          <a href="https://sokkerduel.com/como-funciona/#convide" target="_blank">
            <img src="../../assets/image/banner/banner_1.png" class="d-block w-100 border_radius" alt="...">
          </a>
        </p>
      </div>
    </div>
  </div>
  <!-- banners: fim -------- -->


  <!-- jogos -->
  <div class="container">
    <div class="row">

      <div class="col-md-2">
          <div class="row filtro">

              <div class="col mb-3">
                <router-link :to="{name:'turbo'}" style="text-decoration: none;">
                <img src="../../assets/image/banner/turbo.gif" class="img-fluid" style="border-radius: 10%;">
                </router-link>
              </div>

              <router-link :to="{name:'home_torneio', params:{tipo_id:2, tag_id:0}}" style="text-decoration: none;">
                <div class="card fixed mb-3">
                  <div class="card-body">

                    <div class="row">
                      <div class="col-9 text_12 text_bold pt-1"> TORNEIOS </div>
                      <div class="col-2 text-end text_bold"> > </div>
                    </div>

                    <div v-if="torneio_fixed.length > 0 || torneio_free.length > 0">
                      <div class="text_11 mb-2">{{estatistica.torneio_qtd}} Disponíveis</div>
                      <div class="text_11 text_bold"> ENTRADAS A PARTIR:</div>
                      <div class="text_11 mb-2"> {{estatistica.torneio_entrada_a_partir}} </div>
                      <div class="text_11 text_bold">PRÓXIMO:</div>
                      <div class="text_12 text_amarelo text_bold">Começa em: {{comeca_torneio_proximo}} </div>
                    </div>

                  </div>
                </div>
              </router-link>

              <router-link :to="{name:'home_torneio', params:{tipo_id:1, tag_id:0}}" style="text-decoration: none;">
                <div class="card h2h mb-3">
                  <div class="card-body">

                    <div class="row">
                      <div class="col-9 text_12 text_bold pt-1"> 1 CONTRA 1 </div>
                      <div class="col-2 text-end text_bold"> > </div>
                    </div>

                    <div v-if="torneio_h2h.length > 0">
                      <div class="text_11 mb-2">{{estatistica.h2h_qtd}} Disponíveis</div>
                      <div class="text_11 text_bold"> ENTRADAS A PARTIR:</div>
                      <div class="text_11 mb-2"> {{estatistica.h2h_entrada_a_partir}} </div>
                      <div class="text_11 text_bold">PRÓXIMO:</div>
                      <div class="text_12 text_amarelo text_bold">Começa em: {{comeca_h2h_proximo}} </div>
                    </div>

                  </div>
                </div>
              </router-link>

          </div>
      </div>

      <div class="col-md-10">

        <!-- Filtro/Visualizar-->
        <div class="row mb-3">

              <div class="col-md-2">
                <div class="form-group">
                  <select class="form-control form-control-sm" v-model="frm_torneio_tipo" @change="filtro_tipo(frm_torneio_tipo)">
                    <option value=0>Todos</option>
                    <option value=1>Um contra o outro</option>
                    <option value=2>Preço fixo</option>
                    <option value=3>Torneios grátis</option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <select class="form-control form-control-sm" v-model="frm_torneio_buy_in" @change="filtro_buy_in(frm_torneio_buy_in)">
                    <option value="all">Valor de entrada</option>
                    <option value="r1">0 - 5R$</option>
                    <option value="r2">R$5 - R$30</option>
                    <option value="r3">R$30 - R$100 </option>
                    <option value="r4">R$100 - em diante  </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <select class="form-control form-control-sm" v-model="frm_torneio_next" @change="filtro_next(frm_torneio_next)">
                    <option value="all">Próximos torneios</option>
                    <option value="1H">Começa em 1 horas</option>
                    <option value="2H">Começa em 2 horas</option>
                    <option value="3H">Começa em 3 horas</option>
                    <option value="24H">Começa em 24 horas</option>
                    <option value="+24H"> Maior que 24 horas</option>
                  </select>
                </div>
              </div>

              <div class="col-md-4 text_branco text-end">
                Visualizar: &nbsp;
                <img src="../../assets/image/mosaic.png" width="20px" alt="..." @click="show_layout1()" style="cursor:pointer;"> &nbsp;
                <img src="../../assets/image/list.png" width="20px" alt="..." @click="show_layout2()" style="cursor:pointer;">
              </div>

        </div>
        <!-- Filtro/Visualizar: fim--> 

        <!-- tags ----------------------------------------------------------------------->
        <section class="mb-4">
          <div style="overflow-x: auto; display: flex;">
            <div class="mb-3" style="flex: 0 0 auto;">
              <div class="tag" v-for="tag of tags">
                <router-link :to="{name:'home_torneio', params:{tipo_id:0,tag_id:tag.tag_id}}" style="text-decoration: none;">
                    <button class="btn btn-sm" @click="filtro_tag(tag.tag_id)" v-bind:class="[tag.tag_id==tag_id ? 'btn-warning' : 'btn-outline-warning']">
                      {{tag.tag_nome}}
                    </button>
                </router-link>
              </div>
            </div>
          </div>
        </section>

        <!-- layout 1111111111111: cards --------------------------------------------------------------->
        <section v-show="layout1">
          <div class="row p-0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;">
            <div class="col-md-12 p-0">

                      <!--DESTAQUES-->
                      <div class="mb-3" style="background: linear-gradient(rgba(255, 255, 255, 0.05) 0%, rgba(128, 128, 128, 0) 100%);" v-show="qtd_torneio_destaque > 0">
                          <section id="torneio_free_destaque" class="p-4">
                              <div class="col-12 mb-2">
                                  <div class="text_branco text_bold text_15 mb-3" style="border-left: solid 2px #fff; padding: 0px 0px 0px 10px; background:transparent;">
                                  DESTAQUES TORNEIOS </div>
                              </div>

                              <ccCardDestaque1 ref="cc_card_destaque1"></ccCardDestaque1>
                              <ccCardDestaque2 ref="cc_card_destaque2"></ccCardDestaque2>
                              <ccCardDestaque3 ref="cc_card_destaque3"></ccCardDestaque3>
                          </section>
                      </div>
                      <!--DESTAQUES : FIM-->

                      <!--PROXIMO ACONTECER-->
                      <section class="p-4" v-show="this.original.length > 0">
                          <div class="col-12 mb-2">
                              <div class="text_branco text_bold text_15 mb-3"> PRÓXIMOS A ACONTECER  </div>

                              <ccCardProximo1 ref="cc_card_proximo1"></ccCardProximo1>
                              <ccCardProximo2 ref="cc_card_proximo2"></ccCardProximo2>
                              <ccCardProximo3 ref="cc_card_proximo3"></ccCardProximo3>
                          </div>
                      </section>
                      <!--PROXIMO ACONTECER : FIM-->

                      <!--TELA DE NENHUM TORNEIO-->
                      <section class="p-4" v-show="this.original.length == 0">
                          <div class="col-12 mb-2">
                              <div class="text-center text_branco text_15 mb-3">
                                <br><br>
                                Não existe nenhum torneio ativo no momento <br>
                                Use o filtro acima para ver mais torneios ou
                                    <router-link to="/home/torneio/0"><b class="text_verde" style="text-decoration:none;">clique aqui</b></router-link>
                                para ver torneios das próximas horas
                                <br><br>
                              </div>

                          </div>
                      </section>
                      <!--TELA DE NENHUM TORNEIO: FIM-->

            </div>
          </div>
        </section>
        <!-- layout 1111111111111: fim ------------------------------------------------------------->

        <!-- layout 2222222222222: listas ------------------------------------------------------------------>
        <section v-show="layout2">
          <div class="row p-0" style="background: transparent linear-gradient(163deg, #FFFFFF0D 0%, #80808000 100%) 0% 0% no-repeat padding-box;">
          <div class="col-md-12 p-0">

                    <!--DESTAQUES-->
                    <div class="mb-3" style="background: linear-gradient(rgba(255, 255, 255, 0.05) 0%, rgba(128, 128, 128, 0) 100%);" v-show="qtd_torneio_destaque > 0">
                        <section id="torneio_free_destaque" class="p-4">
                            <div class="col-12 mb-2">
                                <div class="text_branco text_bold text_15 mb-3" style="border-left: solid 2px #fff; padding: 0px 0px 0px 10px; background:transparent;">
                                DESTAQUES TORNEIOS </div>
                            </div>

                            <div class="row pb-2">
                                <div class="col-md-4 text_12 text_cinza"> Torneio </div>
                                <div class="col-md-2 text_12 text_cinza text-center"> Equivale a uma Odd: </div>
                                <div class="col-md-1 text_12 text_cinza text-cente"> Participantes/Max </div>
                                <div class="col-md-2 text_12 text_cinza text-center"> Começa em: </div>
                            </div>

                            <ccListaDestaque1 ref="cc_lista_destaque1"></ccListaDestaque1>
                            <ccListaDestaque2 ref="cc_lista_destaque2"></ccListaDestaque2>
                            <ccListaDestaque3 ref="cc_lista_destaque3"></ccListaDestaque3>

                        </section>
                    </div>
                    <!--DESTAQUES : FIM-->

                    <!--PROXIMO ACONTECER-->
                    <section class="p-4" v-show="this.original.length > 0">
                        <div class="col-12 mb-2">
                            <div class="text_branco text_bold text_15 mb-3"> PRÓXIMOS A ACONTECER </div>

                            <div class="row pb-2">
                                <div class="col-md-4 text_12 text_cinza"> Torneio </div>
                                <div class="col-md-2 text_12 text_cinza text-center"> Equivale a uma Odd: </div>
                                <div class="col-md-1 text_12 text_cinza text-cente"> Participantes/Max </div>
                                <div class="col-md-2 text_12 text_cinza text-center"> Começa em: </div>
                            </div>

                            <ccListaProximo1 ref="cc_lista_proximo1"></ccListaProximo1>
                            <ccListaProximo2 ref="cc_lista_proximo2"></ccListaProximo2>
                            <ccListaProximo3 ref="cc_lista_proximo3"></ccListaProximo3>
                            <!-- <ccListaProximo4 ref="cc_lista_proximo4"></ccListaProximo4> -->

                        </div>
                    </section>
                    <!--PROXIMO ACONTECER : FIM-->

                    <!--TELA DE NENHUM TORNEIO-->
                    <section class="p-4" v-show="this.original.length == 0">
                        <div class="col-12 mb-2">
                            <div class="text-center text_branco text_15 mb-3">
                              <br><br>
                              Não existe nenhum torneio ativo no momento <br>
                              Use o filtro acima para ver mais torneios ou
                                  <router-link to="/home/torneio/0"><b class="text_verde" style="text-decoration:none;">clique aqui</b></router-link>
                              para ver torneios das próximas horas
                              <br><br>
                            </div>

                        </div>
                    </section>
                    <!--TELA DE NENHUM TORNEIO: FIM-->

          </div>
          </div>
        </section>
        <!-- layout 2222222222222: fim ------------------------------------------------------------->

      </div>

    </div>
  </div>
  <!-- jogos:fim -->


</section>
<!-- DESKTOP FIM **********************************************************************************************-->

<ccDetalheTorneio ref="cc_detalhe_torneio"></ccDetalheTorneio>

<ccFooter></ccFooter>

</div>
</template>

<script>

  import io from 'socket.io-client'
  import axios from 'axios'
  import ccMenu from '../layout/menu.vue'
  import ccFooter from '../layout/footer.vue'
  import ccContagemRegressiva from '../cc_geral/cc_contagem_regressiva.vue'
  import ccMensagem from '../cc_geral/mensagem.vue'
  import ccAlert from '../cc_geral/cc_alert.vue'
  import ccLoading from '../cc_geral/cc_loading.vue'
  import ccDetalheTorneio from '../cc_geral/cc_detalhe_torneio_modal.vue'
  import Cookies from 'js-cookie'

  import ccCardDestaque1 from './home_cc_card.vue'
  import ccCardDestaque2 from './home_cc_card.vue'
  import ccCardDestaque3 from './home_cc_card.vue'
  import ccCardProximo1 from './home_cc_card.vue'
  import ccCardProximo2 from './home_cc_card.vue'
  import ccCardProximo3 from './home_cc_card.vue'

  import ccListaDestaque1 from './home_cc_lista.vue'
  import ccListaDestaque2 from './home_cc_lista.vue'
  import ccListaDestaque3 from './home_cc_lista.vue'
  import ccListaProximo1 from './home_cc_lista.vue'
  import ccListaProximo2 from './home_cc_lista.vue'
  import ccListaProximo3 from './home_cc_lista.vue'

  export default {
    data () {
      return {
        //socket
        socket : {},
        canal : "canal_home",
        countSocket: 0,
        fala_servidor: null,
        fonte: null,

        //geral
        base_url_api: process.env.BASE_URL_API,
        user: {},
        loading: false,
        errors:[],

        //array
        original: [],
        torneio: [],
        torneio_fixed: [],
        torneio_fixed_proximos: [],
        torneio_h2h: [],
        torneio_h2h_proximos: [],
        torneio_free: [],
        torneio_free_proximos: [],
        tags: [],

        //variaveis
        layout1: true,
        layout2: false,
        estatistica: {},
        comeca_torneio_proximo: 0,
        comeca_h2h_proximo: 0,
        comeca_free_proximo: 0,
        tag_id: null,

        //qtd
        qtd_torneio_destaque: 0,
        qtd_torneio_fixed: 0,
        qtd_torneio_fixed_destaque: 0,
        qtd_torneio_h2h: 0,
        qtd_torneio_h2h_destaque: 0,
        qtd_torneio_free: 0,
        qtd_torneio_free_destaque: 0,

        channel: null,

        //filtro
        frm_torneio_tipo: 0,
        frm_torneio_buy_in: 'all',
        frm_torneio_next: 'all',
        timer_torneio_horario: null,

        menorDif1: Infinity,
        difAtual1: 0,
        menorDif2: Infinity,
        difAtual2: 0,
      }
    },

    components: {
      ccMenu, ccFooter, ccContagemRegressiva, ccMensagem, ccAlert, ccLoading, ccDetalheTorneio,
      ccCardDestaque1,ccCardDestaque2,ccCardDestaque3,
      ccCardProximo1,ccCardProximo2,ccCardProximo3,
      ccListaDestaque1,ccListaDestaque2,ccListaDestaque3,
      ccListaProximo1,ccListaProximo2,ccListaProximo3,
    },

    created(){
      document.title = 'SokkerDuel - Fantasy Game de Palpites';

      this.escute_canal()
      localStorage.setItem("base_url_api_mobile", this.base_url_api);

      let layout_card = Cookies.get('sokkerduel_layout_card');
      if(layout_card != undefined || layout_card != null){
        if(layout_card == 1){
          this.layout1 = true
          this.layout2 = false
        }else{
          this.layout1 = false
          this.layout2 = true
        }
      }
    },

    mounted(){
      let a = JSON.parse(localStorage.getItem("user"));

      if (a == null){
        this.user = {}
      }else{
        this.user = a
      }

      this.get_all_torneio_abertos()
      this.start_time()
    },

    methods: {

        escute_canal(){
          this.loading = true;

          // this.socket = io(process.env.BASE_SOCKET).on('countSocket', (data) => {
          //   console.log("assistindo: " + data)
          // });

          this.socket = this.$store.state.socket

          //quantos logados no socket
          this.channel = this.socket.on('countSocket', (data) => {
            this.countSocket = data;
          });

          this.socket.on('canal_home', (data) => {
            this.fonte = data.fonte
            this.original = data.resp.torneios
            this.estatistica = data.resp.estatisticas
            this.tags = data.resp.tags;
            this.higienizar()
            this.loading = false
          });
        },

        get_all_torneio_abertos(){
          this.loading = true;
          var header = {'headers': {'x-access-token': this.user.access_token, }};
          axios.get(this.base_url_api+'home', header)
          .then(response => {
            this.fonte = response.data.fonte
            this.original = response.data.resp.torneios
            this.estatistica = response.data.resp.estatisticas
            this.tags = response.data.resp.tags;
            this.higienizar()
            this.loading = false;
          })
          .catch(e => {
            this.errors.push(e);
            // alert(e)
            this.expluse()
          });
        },

        higienizar(){
          let agora = Date.now()
          let a = this.original
          var obj = {}
          this.tor = []
          this.torneio = []

          this.qtd_torneio_destaque = 0

          this.qtd_torneio_fixed = 0
          this.qtd_torneio_fixed_destaque = 0

          this.valor_entrada_fixed_min = 0
          this.valor_entrada_fixed_max = 0

          this.qtd_torneio_h2h = 0
          this.qtd_torneio_h2h_destaque = 0

          this.valor_entrada_h2h_min = 0
          this.valor_entrada_h2h_max = 0

          this.qtd_torneio_free = 0
          this.qtd_torneio_free_destaque = 0

          this.valor_entrada_free_min = 0
          this.valor_entrada_free_max = 0

          let dif = 0;

          for (var i=0; i <= a.length -1; i++) {
            if(a[i].qtd_aposta < a[i].max_pessoa) {
              if( a[i].tipo_id == this.frm_torneio_tipo || this.frm_torneio_tipo == 0 ){

                  //estatisticas ------------------------------------
                  if(a[i].tipo_id == 1){
                    this.qtd_torneio_h2h++

                    if(a[i].taxa_entrada > this.valor_entrada_h2h_max){
                      this.valor_entrada_h2h_max = a[i].taxa_entrada
                    }

                    if(a[i].destaque == 1){ this.qtd_torneio_destaque++ }
                  }

                  if(a[i].tipo_id == 2){
                    this.qtd_torneio_fixed++

                    if(a[i].taxa_entrada > this.valor_entrada_fixed_max){
                      this.valor_entrada_fixed_max = a[i].taxa_entrada
                    }

                    if(a[i].destaque == 1){ this.qtd_torneio_destaque++ }
                  }

                  if(a[i].tipo_id == 3){
                    this.qtd_torneio_free++
                    if(a[i].destaque == 1){ this.qtd_torneio_destaque++ }
                  }
                  // --------------------------------------------------

                  dif = ( (a[i].dt_inicio_timestamp * 1000) - agora )
                  dif = parseInt(dif/1000);

                  if(dif > 0){
                    obj = {
                      id :a[i].id,
                      nome :a[i].nome,
                      tipo_id :a[i].tipo_id,
                      sumario :a[i].sumario,
                      dt_inicio_timestamp :a[i].dt_inicio_timestamp,
                      descricao_pagamento :a[i].descricao_pagamento,
                      odd :a[i].odd,
                      taxa_entrada :a[i].taxa_entrada,
                      min_pessoa :a[i].min_pessoa,
                      max_pessoa :a[i].max_pessoa,
                      max_reentrada :a[i].max_reentrada,
                      qtd_aposta :a[i].qtd_aposta,
                      qtd_jogo :a[i].qtd_jogo,
                      qtd_mercado_obrigatorio :a[i].qtd_mercado_obrigatorio,
                      prize :a[i].prize,
                      status :a[i].status,
                      status_nome :a[i].status_nome,
                      destaque :a[i].destaque,
                      jogo: a[i].jogo,
                      dt_termino_timestamp: a[i].dt_termino_timestamp,
                      dif: dif,
                      time_regressivo: 0,
                      tag_id: a[i].tag_id,
                      tag_nome: a[i].tag_nome,
                    }
                  }

                  this.torneio.push(obj);
              }
            }
          }

          //filtro buy_in
          if (this.frm_torneio_buy_in == 'r1') {
              this.torneio = this.torneio.filter((item) => item.taxa_entrada >= 0  && item.taxa_entrada <= 150)
          } else if (this.frm_torneio_buy_in == 'r2') {
              this.torneio = this.torneio.filter((item) => item.taxa_entrada > 5  && item.taxa_entrada <= 30)
          } else if (this.frm_torneio_buy_in == 'r3') {
              this.torneio = this.torneio.filter((item) => item.taxa_entrada > 30  && item.taxa_entrada <= 100)
          } else if (this.frm_torneio_buy_in == 'r4') {
              this.torneio = this.torneio.filter((item) => item.taxa_entrada > 100)
          }

          //filtro next
          if( this.frm_torneio_next == '1H'){
              this.torneio = this.torneio.filter((item) => item.dif <= 3600)
          } else if( this.frm_torneio_next == '2H'){
              this.torneio = this.torneio.filter((item) => item.dif <= 3600 * 2)
          } else if( this.frm_torneio_next == '3H'){
              this.torneio = this.torneio.filter((item) => item.dif <= 3600 * 3)
          } else if( this.frm_torneio_next == '24H'){
              this.torneio = this.torneio.filter((item) => item.dif <= 3600 * 24)
          } else if( this.frm_torneio_next == '+24H'){
              this.torneio = this.torneio.filter((item) => item.dif > 3600 * 24)
          }

          this.torneio_h2h = this.torneio.filter((item) => item.tipo_id == 1);
          this.torneio_fixed = this.torneio.filter((item) => item.tipo_id == 2);
          this.torneio_free = this.torneio.filter((item) => item.tipo_id == 3);
          this.torneio_turbo = this.torneio.filter((item) => item.tipo_id == 4);

          if(this.tag != null){
            this.torneio = this.torneio.filter((item) => item.tag_nome == this.tag)
          }

          //get o menor em tempos - h2h
          let aux_menor = 99999999999999999999
          for (var i=0; i <= this.torneio_h2h.length -1; i++) {
            if( this.torneio_h2h[i].destaque == 0 && this.torneio_h2h[i].dif <= aux_menor ){
              aux_menor = this.torneio_h2h[i].dif
            }
          }
          this.torneio_h2h_proximos = this.torneio_h2h.filter((item) => item.dif == aux_menor);

          //get o menor em tempos - fixed
          aux_menor = Infinity
          for (var i=0; i <= this.torneio_fixed.length -1; i++) {
            if(this.torneio_fixed[i].destaque == 0 && this.torneio_fixed[i].dif < aux_menor ){
              aux_menor = this.torneio_fixed[i].dif
            }
          }
          this.torneio_fixed_proximos = this.torneio_fixed.filter((item) => item.dif == aux_menor);

          //get o menor em tempos - free
          aux_menor = 9999999999999999999999999
          for (var i=0; i <= this.torneio_free.length -1; i++) {
            if(this.torneio_free[i].destaque == 0 && this.torneio_free[i].dif <= aux_menor ){
              aux_menor = this.torneio_free[i].dif
            }
          }
          this.torneio_free_proximos = this.torneio_free.filter((item) => item.dif == aux_menor);

          //get o menor em tempos - turbo
          aux_menor = Infinity
          for (var i=0; i <= this.torneio_turbo.length -1; i++) {
            if(this.torneio_fixed[i].destaque == 0 && this.torneio_fixed[i].dif < aux_menor ){
              aux_menor = this.torneio_fixed[i].dif
            }
          }
          this.torneio_turbo_proximos = this.torneio_turbo;

          this.$refs.cc_card_destaque1.receber_dados(1, this.torneio_h2h, 1)
          this.$refs.cc_card_destaque2.receber_dados(2, this.torneio_fixed, 1)
          this.$refs.cc_card_destaque3.receber_dados(3, this.torneio_free, 1)
          this.$refs.cc_card_proximo1.receber_dados(1, this.torneio_h2h_proximos, 0)
          this.$refs.cc_card_proximo2.receber_dados(2, this.torneio_fixed_proximos, 0)
          this.$refs.cc_card_proximo3.receber_dados(3, this.torneio_free_proximos, 0)

          this.$refs.cc_lista_destaque1.receber_dados(1, this.torneio_h2h, 1)
          this.$refs.cc_lista_destaque2.receber_dados(2, this.torneio_fixed, 1)
          this.$refs.cc_lista_destaque3.receber_dados(3, this.torneio_free, 1)
          this.$refs.cc_lista_proximo1.receber_dados(1, this.torneio_h2h_proximos, 0)
          this.$refs.cc_lista_proximo2.receber_dados(2, this.torneio_fixed_proximos, 0)
          this.$refs.cc_lista_proximo3.receber_dados(3, this.torneio_free_proximos, 0)
        },

        filtro_tipo(tipo){
          this.frm_torneio_tipo = tipo
          this.higienizar()
        },

        filtro_buy_in(buy_in){
          this.frm_torneio_buy_in = buy_in
          this.higienizar()
        },

        filtro_next(next){
          this.frm_torneio_next = next
          this.higienizar()
        },

        filtro_tag(tag){
          this.tag = tag
          this.higienizar()
        },

        start_time(){
            this.timer_torneio_horario = setInterval( function(){

            for (var i=0; i < this.torneio_h2h.length; i++){
              this.torneio_h2h[i].dif = this.torneio_h2h[i].dif - 1;
              this.torneio_h2h[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio_h2h[i].dif )

              this.difAtual1 = this.torneio_h2h[i].dif;
              if (this.difAtual1 < this.menorDif1) {
                  this.comeca_h2h_proximo = this.torneio_h2h[i].time_regressivo
                  this.menorDif1 = this.difAtual1
              }
            }

            for (var i=0; i < this.torneio_fixed.length; i++){
              this.torneio_fixed[i].dif = this.torneio_fixed[i].dif - 1;
              this.torneio_fixed[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio_fixed[i].dif )

              if(this.torneio_fixed[i].tipo_id == 2){
                this.difAtual2 = this.torneio_fixed[i].dif;
                if (this.difAtual2 < this.menorDif2) {
                    this.comeca_torneio_proximo = this.torneio_fixed[i].time_regressivo
                    this.menorDif2 = this.difAtual2
                }
              }
            }

            for (var i=0; i < this.torneio_free.length; i++){
              this.torneio_free[i].dif = this.torneio_free[i].dif - 1;
              this.torneio_free[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio_free[i].dif )
            }

          }.bind(this), 1000);
        },

        expluse(){
          this.$router.push({ path: '/', replace: true })
        },

        show_detalhe_torneio(torneio_id){
          this.$refs.cc_detalhe_torneio.receber_dados(torneio_id);
        },

        show_layout1(){
          this.layout1 = true
          this.layout2 = false
          Cookies.set('sokkerduel_layout_card', 1, { expires: 30 } )
        },

        show_layout2(){
          this.layout1 = false
          this.layout2 = true
          Cookies.set('sokkerduel_layout_card', 2, { expires: 30 } )
        },

    },

    destroyed(){
      this.socket.off('canal_home');
    }

  }
</script>

<style scoped>

    .filtro .card{
      color:  #ffffffE6;
      letter-spacing: 0px;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 18px;
      opacity: 1;
    }

    .filtro .fixed{
      background: transparent linear-gradient(223deg, #4D9220 0%, #264812 100%) 0% 0% no-repeat padding-box;
    }

    .filtro .h2h{
      background: transparent linear-gradient(227deg, #8A3DD5 0%, #351357 100%) 0% 0% no-repeat padding-box;
    }

    .destaque_traco_verde{
      top: 502px;
      left: 26px;
      width: 265px;
      height: 3px;
      background: transparent linear-gradient(270deg, #FFFFFF00 0%, #5ABB10 100%) 0% 0% no-repeat padding-box;
    }

    .card_verde{
      padding: 6px 0 0 8px;
      border: 0;
      border-radius:10px 10px 0px 0;
      background: transparent linear-gradient(0deg, #FFFFFF00 0%, #5ABB1026 100%) 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 8px #00000029;
    }

    .destaque_traco_roxo{
      top: 502px;
      left: 26px;
      width: 265px;
      height: 3px;
      background: transparent linear-gradient(270deg, #FFFFFF00 0%, #B01CD4 100%) 0% 0% no-repeat padding-box;
      opacity: 1;
    }

    .card_roxo{
      padding: 6px 0 0 8px;
      border: 0;
      border-radius:10px 10px 0px 0;
      background: transparent linear-gradient(65deg, #FFFFFF00 0%, #B01CD433 100%) 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 8px #00000029;
    }

    .destaque_traco_laranja{
      top: 502px;
      left: 26px;
      width: 265px;
      height: 3px;
      background: transparent linear-gradient(270deg, #FFFFFF00 0%, orange 100%) 0% 0% no-repeat padding-box;
      opacity: 1;
    }


    .form-control {
      color: #ffffff80;
      background-color: #333644;
      border: none;
    }


    #torneio_free_destaque {
      background: linear-gradient(rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.03) 100%);
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
	  }

    .cardi{
      background: transparent linear-gradient(81deg, #FFFFFF05 0%, #FFD99816 48%, #FFB43326 100%) 0% 0% no-repeat padding-box;
      border-radius: 10px;
		}

    .tag{
      float: left;
      padding-right: 15px;
    }


    /* Largura da barra de rolagem */
    ::-webkit-scrollbar {
      width: 10px; /* largura */
      height: 5px; /* altura */
    }

    /* Cor da barra de rolagem */
    ::-webkit-scrollbar-track {
      background: #0A0D1A;
    }

    /* Cor do indicador da posição atual da barra de rolagem */
    ::-webkit-scrollbar-thumb {
      background: #686868;
    }

    /* Arredondar as bordas do indicador da barra de rolagem */
    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/components/home/home.vue